import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      industryOverview: {
        INDUSTRY: 'Industry',
        TOOLTIP_INDUSTRY: `The industry of a company is defined as the level 3 of VSIC
          classification of its main business. If the the main business
          matches the level 1 or level 2 of VSIC classification standard,
          the main business is considered as the industry. If a company has
          two or more main businesses, a non-main business covering most
          activities with will be set to identify its industry.`,
        QUANTITY_COMPANIES: '%{quantity} Companies',
        TOTAL_FDI_OF_THE_LEVEL_INDUSTRY: 'TOTAL FDI OF THE Level 1 Industry',
        PROPORTION_OF_ACTIVE_COMPANIES: 'Proportion of Active Companies',
        MOST_POPULAR_BUSINESS_SIZE: 'Most Popular Business Size',
        MOST_POPULAR_YEAR_OF_OPERATION: ' Most Popular Years in Operation',
        NOTICE: 'Notice',
        NOTICE_DESC:
          'The information about industry of the company is not defined, so the data of this section is not available at the moment.',
        BANKING_INDUSTRY: 'Banking Industry',
        SECURITIES_INDUSTRY: 'Securities Industry',
        LIFE_INSURANCE_INDUSTRY: 'Life Insurance',
        NON_LIFE_INSURANCE_INDUSTRY: 'Non-life Insurance',
        NON_BANK_FIC_INDUSTRY: 'Finance Company',
        NON_BANK_FIO_INDUSTRY: 'Other Financial Institutions',
        NON_BANK_LEA_INDUSTRY: 'Leasing Company',
        recentNews: {
          RECENT_NEWS: 'Recent News',
          SENTIMENT: 'Sentiment',
          HEADLINE: 'Headline',
          EVENT: 'Event',
          PUBLICATION_DATE: 'Publication Date',
          VIEW_DETAILS: 'View details',
        },
        industryScale: {
          INDUSTRY_SCALE: 'Industry Scale',
          INDUSTRY_TOTAL_ASSETS: 'Industry Total Assets',
          INDUSTRY_NET_REVENUE: 'Industry Total Operating Income',
          CORP_INDUSTRY_NET_REVENUE: 'Industry Net Revenue',
          INS_INDUSTRY_NET_REVENUE: 'Revenue from Insurance Premium',
          NUMBER_OF_ACTIVE_BUSINESS: 'Number of Revenue-generating Companies',
          BANKS_NUMBER_OF_ACTIVE_BUSINESS: 'Number of Revenue-generating Banks',
          INS_NUMBER_OF_ACTIVE_BUSINESS:
            'Number of Revenue from Insurance Premium-generating Companies',
          NUMBER_OF_OPERATING_INCOME:
            'Number of Operating Income-generating Companies',
        },
        businessProvince: {
          BUSINESS_BY_PROVINCE: 'Business Allocation by Province',
          RANK: 'Rank',
          PROVINCE: 'Province',
          REGION: 'Region',
          NUMBER_OF_COMPANIES: 'Number of Companies',
          TOTAL_COMPANIES_PERCENT: '% of Total Companies',
          TOOLTIP: 'Including Active Headquarters & Branches',
          TABLE: 'Table',
          MAP: 'Map',
        },
        businessYears: {
          BUSINESS_BY_YEARS: 'Business Allocation by Years in Operation',
          YEARS_OF_OPERATION: 'Years in Operation',
          NUMBER_OF_COMPANIES: 'Number of Companies',
          TOTAL_COMPANIES_PERCENT: '% of Total Companies',
          TOOLTIP: 'Active Companies Only',
          BANK_TOOLTIP: 'Active Banks Only',
        },
        topIndustryPlayers: {
          TOP_INDUSTRY_PLAYERS: 'Top Industry Players ',
          RANK: 'Rank',
          COMPANY_NAME: 'Company Name',
          TOTAL_ASSETS: 'Total Assets',
          CORP_NET_REVENUE: 'Net Revenue',
          NET_REVENUE: 'Total Operating Income',
          REVENUE_INSURANCE: 'Revenue from Insurance Premium',
          FY: 'FY:',
          RANK_BY: 'Rank By:',
        },
        businessSize: {
          BUSINESS_BY_SIZE: 'Business Allocation by Size',
          BUSINESS_SIZE: 'Business Size',
          REVENUE_RANGE: 'Revenue Range',
          NUMBER_OF_COMPANIES: 'Number of Companies',
          TOTAL_COMPANIES_PERCENT: '% of Total Companies',
          TOOLTIP: 'Active Companies Only',
          BANK_TOOLTIP: 'Active Banks Only',
        },
        businessStatus: {
          BUSINESS_OPERATING_STATUS: 'Business Allocation by Operating Status',
          OPERATING_STATUS: 'Operating Status',
          NUMBER_OF_COMPANIES: 'Number of Companies',
          TOTAL_COMPANIES_PERCENT: '% of Total Companies',
        },
        macroeconomics: {
          MACROECONOMICS: 'Macroeconomics',
          IMPORT_EXPORT: 'Import - Export',
          SOURCE_GENERAL: 'Source: General Statistics Office of Vietnam',
          GDP_GDP_GROWTH_RATE: 'GDP & GDP Growth Rate:',
          REAL_GDP: 'Real GDP',
          NOMINAL_GDP: 'Nominal GDP',
          TOOLTIP_REAL_GDP:
            'Real GDP is an inflation-adjusted measure of Gross Domestic Product, which is expressed in base-year prices (%{year})',
          TOOLTIP_NOMINAL_GDP:
            'Nominal GDP is the value of Gross Domestic Product given in current prices, without adjustment for inflation',
          GDP_BY_INDUSTRIES: 'GDP by Industries',
          FDI_CURRENT_PRICE_GROWTH_RATE:
            'FDI at Current Prices and FDI Growth Rate:',
          FDI_BY_INDUSTRIES: 'FDI at Current Prices by Industries',
          IMPORT_EXPORT_TRADE_VALUE: 'Import-Export and Balance of Trade',
          IMPORT_EXPORT_PRICE: 'Import-Export at Current Prices by Industries',
          IMPORT_EXPORT_GROWTH_RATE:
            'Import-Export and Balance of Trade Growth Rate',
          SHOW_DATA_INDUSTRIES: 'Show Data of All Industries',
          SORT_BY: 'Sort By:',
          CHART: 'Chart',
          TABLE: 'Table',
          IMPORT: 'Import',
          IMPORT_ASCENDING: 'Import (Ascending)',
          IMPORT_DESCENDING: 'Import (Descending)',
          EXPORT: 'Export',
          EXPORT_ASCENDING: 'Export (Ascending)',
          EXPORT_DESCENDING: 'Export (Descending)',
          BALANCE_OF_TRADE: 'Balance of Trade',
          BALANCE_TRADE_ASCENDING: 'Balance of Trade (Ascending)',
          BALANCE_TRADE_DESCENDING: 'Balance of Trade (Descending)',
          FDI_GROWTH_RATE_INDUSTRY:
            'FDI at Current Prices and FDI Growth Rate:',
          IMPORT_EXPORT_BALANCE_TRADE: 'Import-Export and Balance of Trade:',
          GROWTH_RATE_PERCENT: '% Growth Rate',
          CONTRIBUTION_PERCENT: '% Contribution',
          Name: 'Name',
          GDP_GROWTH_RATE: 'GDP growth rate',
          FDI_GROWTH_RATE: 'FDI growth rate',
          IMPORT_ALL_INDUSTRIES: 'Import (All industries)',
          EXPORT_ALL_INDUSTRIES: 'Export (All industries)',
          BALANCE_OF_TRADE_ALL_INDUSTRIES: 'Balance of Trade (All industries)',
          VALUE: 'Value',
          GROWTH_RATE: 'Growth Rate',
          REAL_GDP_GROWTH_RATE: 'Real GDP and Real GDP Growth Rate',
          NOMINAL_GDP_GROWTH_RATE: 'Nominal GDP and Nominal GDP Growth Rate',
          REAL_GDP_INDUSTRY: 'Real GDP by Industries',
          NOMINAL_GDP_INDUSTRY: 'Nominal GDP by Industries',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      industryOverview: {
        INDUSTRY: 'Ngành',
        TOOLTIP_INDUSTRY: `Ngành của một công ty được xác định là cấp 3 trong phân loại VSIC
          theo lĩnh vực kinh doanh chính của công ty. Nếu lĩnh vực kinh doanh
          chính của công ty trùng khớp hoàn toàn với phân loại cấp 1 hoặc cấp 2
          của VSIC thì ngành kinh doanh chính được coi là ngành.`,
        QUANTITY_COMPANIES: '%{quantity} Doanh nghiệp',
        TOTAL_FDI_OF_THE_LEVEL_INDUSTRY: 'Tổng FDI toàn ngành - cấp 1',
        PROPORTION_OF_ACTIVE_COMPANIES: 'Tỷ lệ doanh nghiệp đang hoạt động',
        MOST_POPULAR_BUSINESS_SIZE: 'Quy mô doanh nghiệp chủ yếu trong ngành',
        MOST_POPULAR_YEAR_OF_OPERATION: 'Số năm hoạt động chủ yếu trong ngành',
        NOTICE: 'Thông báo',
        NOTICE_DESC:
          'Thông tin về ngành của công ty không được xác định, nên dữ liệu thuộc về phần này sẽ không khả dụng ở thời điểm hiện tại',
        BANKING_INDUSTRY: 'Ngành Ngân Hàng',
        SECURITIES_INDUSTRY: 'Ngành Chứng Khoán',
        LIFE_INSURANCE_INDUSTRY: 'Bảo Hiểm Nhân Thọ',
        NON_LIFE_INSURANCE_INDUSTRY: 'Bảo Hiểm Phi Nhân Thọ',
        NON_BANK_FIC_INDUSTRY: 'Công Ty Tài Chính',
        NON_BANK_FIO_INDUSTRY: 'Công Ty Tài Chính Phi Ngân Hàng',
        NON_BANK_LEA_INDUSTRY: 'Công Ty Cho Thuê Tài Chính',
        recentNews: {
          RECENT_NEWS: 'Tin Mới',
          SENTIMENT: 'Trạng thái',
          HEADLINE: 'Tiêu đề',
          EVENT: 'Sự kiện',
          PUBLICATION_DATE: 'Ngày',
          VIEW_DETAILS: 'Xem thêm',
        },
        industryScale: {
          INDUSTRY_SCALE: 'Quy Mô Ngành',
          INDUSTRY_TOTAL_ASSETS: 'Tổng Tài Sản Trong Ngành',
          INDUSTRY_NET_REVENUE: 'Lợi Nhuận Hoạt Động Trong Ngành',
          CORP_INDUSTRY_NET_REVENUE: 'Doanh Thu Thuần Trong Ngành',
          INS_INDUSTRY_NET_REVENUE: 'Doanh Thu Phí Bảo Hiểm',
          NUMBER_OF_ACTIVE_BUSINESS: 'Số Lượng Công Ty Tạo Ra Doanh Thu',
          BANKS_NUMBER_OF_ACTIVE_BUSINESS:
            'Số Lượng Ngân Hàng Tạo Ra Doanh Thu',
          INS_NUMBER_OF_ACTIVE_BUSINESS:
            'Số Lượng Công Ty Tạo Ra Doanh Thu Phí Bảo Hiểm',
          NUMBER_OF_OPERATING_INCOME:
            'Số Lượng Công Ty Tạo Ra Lợi Nhuân Hoạt Động',
        },
        businessProvince: {
          BUSINESS_BY_PROVINCE: 'Tỷ Trọng Doanh Nghiệp Theo Tỉnh Thành',
          RANK: 'Hạng',
          PROVINCE: 'Tỉnh Thành',
          REGION: 'Vùng',
          NUMBER_OF_COMPANIES: 'Số Lượng Doanh Nghiệp',
          TOTAL_COMPANIES_PERCENT: 'Tỷ Trọng',
          TOOLTIP: 'Bao gồm Trụ sở và các Chi nhánh đang hoạt động',
          TABLE: 'Bảng',
          MAP: 'Bản đồ',
        },
        businessYears: {
          BUSINESS_BY_YEARS: 'Tỷ Trọng Doanh Nghiệp Theo Số Năm Hoạt Động',
          YEARS_OF_OPERATION: 'Số Năm Hoạt Động',
          NUMBER_OF_COMPANIES: 'Số Lượng Doanh Nghiệp',
          TOTAL_COMPANIES_PERCENT: 'Tỷ Trọng',
          TOOLTIP: 'Chỉ tính các Doanh nghiệp đang hoạt động',
          BANK_TOOLTIP: 'Chỉ tính các Ngân hàng đang hoạt động',
        },
        topIndustryPlayers: {
          TOP_INDUSTRY_PLAYERS: 'Top Doanh Nghiệp Trong Ngành ',
          RANK: 'Hạng',
          COMPANY_NAME: 'Tên Công Ty',
          TOTAL_ASSETS: 'Tổng Tài Sản',
          CORP_NET_REVENUE: 'Doanh Thu Thuần',
          NET_REVENUE: 'Lợi Nhuận Hoạt Động',
          REVENUE_INSURANCE: 'Doanh thu phí bảo hiểm',
          FY: 'Năm tài khóa:',
          RANK_BY: 'Xếp theo:',
        },
        businessSize: {
          BUSINESS_BY_SIZE: 'Tỷ Trọng Doanh Nghiệp Theo Quy Mô',
          BUSINESS_SIZE: ' Quy Mô',
          REVENUE_RANGE: 'Mức Doanh Thu',
          NUMBER_OF_COMPANIES: 'Số Lượng Doanh Nghiệp',
          TOTAL_COMPANIES_PERCENT: 'Tỷ Trọng',
          TOOLTIP: 'Chỉ tính các Doanh nghiệp đang hoạt động',
          BANK_TOOLTIP: 'Chỉ tính các Ngân hàng đang hoạt động',
        },
        businessStatus: {
          BUSINESS_OPERATING_STATUS:
            'Tỷ Trọng Doanh Nghiệp Theo Trạng Thái Hoạt Động',
          OPERATING_STATUS: 'Trạng Thái Hoạt Động',
          NUMBER_OF_COMPANIES: 'Số Lượng Doanh Nghiệp',
          TOTAL_COMPANIES_PERCENT: 'Tỷ Trọng',
        },
        macroeconomics: {
          MACROECONOMICS: 'Kinh Tế Vĩ Mô',
          IMPORT_EXPORT: 'Xuất nhập khẩu',
          SOURCE_GENERAL: 'Nguồn: Tổng cục Thống kê Việt Nam',
          GDP_GDP_GROWTH_RATE: 'GDP và tăng trưởng GDP theo ngành:',
          REAL_GDP: 'GDP thực tế',
          NOMINAL_GDP: 'GDP danh nghĩa',
          GDP_BY_INDUSTRIES: 'GDP theo ngành',
          TOOLTIP_REAL_GDP:
            'GDP thực tế là một chỉ tiêu đo lường Tổng Sản phẩm quốc nội được điều chỉnh bởi lạm phát, được tính toán dựa trên mức giá cả của năm cơ sở (%{year})',
          TOOLTIP_NOMINAL_GDP:
            'GDP danh nghĩa là giá trị Tổng Sản phẩm quốc nội theo giá hiện hành, không tính tới lạm phát',
          FDI_CURRENT_PRICE_GROWTH_RATE:
            'FDI theo giá hiện hành và tăng trưởng FDI theo ngành:',
          FDI_BY_INDUSTRIES: 'FDI theo giá hiện hành theo ngành',
          IMPORT_EXPORT_TRADE_VALUE:
            'Xuất nhập khẩu và cán cân thương mại theo ngành',
          IMPORT_EXPORT_PRICE: 'Xuất nhập khẩu theo giá hiện hành theo ngành',
          IMPORT_EXPORT_GROWTH_RATE:
            'Tăng trưởng xuất nhập khẩu và cán cân thương mại',
          SHOW_DATA_INDUSTRIES: ' Hiển thị dữ liệu của toàn bộ các ngành',
          SORT_BY: 'Sắp xếp theo:',
          CHART: 'Biểu đồ',
          TABLE: 'Bảng',
          IMPORT: 'Nhập khẩu',
          IMPORT_ASCENDING: 'Nhập khẩu (Tăng dần)',
          IMPORT_DESCENDING: 'Nhập khẩu (Giảm dần)',
          EXPORT: 'Xuất khẩu',
          EXPORT_ASCENDING: 'Xuất khẩu (Tăng dần)',
          EXPORT_DESCENDING: 'Xuất khẩu (Giảm dần)',
          BALANCE_OF_TRADE: 'Cán cân thương mại',
          BALANCE_TRADE_ASCENDING: 'Cán cân Thương mại (Tăng dần)',
          BALANCE_TRADE_DESCENDING: 'Cán cân thương mại (Giảm dần)',
          FDI_GROWTH_RATE_INDUSTRY:
            'FDI theo giá hiện hành và tăng trưởng FDI:',
          IMPORT_EXPORT_BALANCE_TRADE: 'Xuất nhập khẩu và Cán cân thương mại:',
          GROWTH_RATE_PERCENT: 'Tỷ lệ tăng trưởng',
          CONTRIBUTION_PERCENT: 'Tỷ trọng %',
          Name: 'Tên',
          GDP_GROWTH_RATE: 'Tỷ lệ tăng trưởng GDP',
          FDI_GROWTH_RATE: 'Tỷ lệ tăng trưởng FDI',
          IMPORT_ALL_INDUSTRIES: 'Nhập khẩu (Tất cả ngành)',
          EXPORT_ALL_INDUSTRIES: 'Xuất khẩu (Tất cả ngành)',
          BALANCE_OF_TRADE_ALL_INDUSTRIES: 'Cán cân thương mại (Tất cả ngành)',
          VALUE: 'Giá trị',
          GROWTH_RATE: 'Tỷ lệ tăng trưởng',
          REAL_GDP_GROWTH_RATE:
            'GDP thực tế và tăng trưởng GDP thực tế theo ngành',
          NOMINAL_GDP_GROWTH_RATE:
            'GDP danh nghĩa và tăng trưởng GDP danh nghĩa theo ngành',
          REAL_GDP_INDUSTRY: 'GDP thực tế theo ngành',
          NOMINAL_GDP_INDUSTRY: 'GDP danh nghĩa theo ngành',
        },
      },
    },
  }),
)
